import React from "react";

const SupportedCurrencyPairsHeroSection = () =>{
    return(
        <>
        <div className="common-hero">
          <div className="container">
            <div className="row align-items-center text-center">
              <div className="col-lg-6 m-auto">
                <div className="main-heading">
                  <h1>Supported Currency Pairs</h1>
                    <div className="space16"></div>
                    <span className="span"><img src="/assets/img/icons/span1.png" alt=""/> <a href="/">Home</a> <span className="arrow"><i className="fa-solid fa-angle-right"></i></span> Supported Currency Pairs</span>
                </div>
              </div>

            </div>
          </div>
        </div>
        </>        
    )
}

export default SupportedCurrencyPairsHeroSection;